<template>
  <section class="bidsRoot">
    <el-table
      v-if="isLoading || !bids.length"
      v-loading="isLoading"
      :data="[]"
      element-loading-text="Загрузка..."
    >
      <div slot="empty">
        <p v-if="!isError">В настоящее время погрузки отсутствуют</p>
        <template v-else>
          <p class="err-p"><b>Данные не загрузились</b></p>
          <el-button class="mob-btn" type="primary" @click="updatePage">
            Обновить
          </el-button>
        </template>
      </div>
    </el-table>
    <template v-else>
      <div>
        <div
          v-if="flights.length"
          class="flights flex-between-center"
          @click="$router.push('/flights-mobile')"
        >
          <div class="flights__title flex-v-center">
            <div class="flights__title-attention" />
            <div class="flights__title-text">У вас&nbsp;{{ flightsCount }}</div>
          </div>
          <div class="flex-v-center">
            <div v-for="(value, key) in flightTypesCount" :key="key">
              <div v-if="value" class="flights__info flex-v-center">
                <div :class="['flights__info-icon', key]" />
                <div class="flights__info-value">{{ value }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-infinite-scroll="load" :infinite-scroll-disabled="disabled">
          <bid-mobile
            v-for="(bid, i) in bids"
            :key="`${bid.id}_${i}`"
            :bid="bid"
            :freight="freights[bid.freight_id]"
            @set="setBid"
            @ready="onReady(bids, i)"
            v-on="$listeners"
          />
        </div>
        <loader-wrapper
          :loading="loadingInfinite"
          background="rgba(249,249,249,0)"
        >
          <div v-if="loadingInfinite" class="loader ta-c">Загрузка...</div>
        </loader-wrapper>
      </div>
      <el-dialog
        title="Координаты погрузки-выгрузки"
        width="100%"
        class="map-el-dialog"
        :visible.sync="dialog_bid_points"
      >
        <y-map :bid="current" />
      </el-dialog>
    </template>
  </section>
</template>

<script>
import { pluralNew } from '@/helpers/functions'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { getNow } from '@/helpers/date'
import { isBidViewed } from '@/helpers/visibilityOnScroll'
import { mapGetters } from 'vuex'
import BidMobile from './BidMobile'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'
import YMap from '@/components/Maps/YMap'

const Responses = RepositoryFactory.get('responses')

export default {
  name: 'BidsMobile',
  components: { BidMobile, YMap, LoaderWrapper },
  props: {
    bids: {
      type: Array,
      default: () => [],
    },
    freights: {
      type: Object,
      default: () => {},
    },
    page: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      current: {},
      dialog_bid_points: false,
      loadingInfinite: false,
      flights: [],
      flightsError: false,
    }
  },
  computed: {
    ...mapGetters({
      getLoading: 'bids/getLoading',
      isError: 'bids/isError',
      pagination: 'bids/getPagination',
      checkLibs: 'libs/checkLibs',
      getUnloadPointKladrId: 'bids/getUnloadPointKladrId',
    }),
    isLoading() {
      return this.getLoading('Bid') && !this.loadingInfinite
    },
    disabled() {
      return (
        this.page >= this.pagination?.pageCount || 1 || this.loadingInfinite
      )
    },
    // общее число рейсов для плашки
    flightsCount() {
      const flights = ['рейс', 'рейса', 'рейсов']

      return pluralNew(this.flights.length, flights)
    },
    // подсчет рейсов по статусу рейса
    flightTypesCount() {
      let count = { accept: 0, waiting: 0, decline: 0 }

      this.flights.forEach(item => {
        if (item.status === 'accepted') { count.accept++ }
          else if (item.status === 'not_stated') { count.waiting++ }
            else { count.decline++ }
      })

      return count
    },
  },
  created() {
    this.fetchFlights()
  },
  methods: {
    load() {
      if (!this.loadingInfinite) {
        this.loadingInfinite = true
        this.$emit('page', this.page + 1)
        this.fetchBids(true, () => (this.loadingInfinite = false))
      }
    },
    updatePage() {
      this.fetchBids()
    },
    onReady(bids, i) {
      if (i === bids.length - 1) {
        isBidViewed(this, '.infinite-wrap')
      }
    },
    fetchBids(isLoad, callback) {
      this.$emit('fetch', { isLoad, callback })
    },
    setBid(bid, key) {
      this.current = bid
      this[key] = true
    },
    // запрос рейсов для отображения в плашке рейсов
    async fetchFlights() {
      const params = `?date_from=${getNow('YYYY-MM-DD')}`

      try {
        let { data } = await Responses.getFlights(params)

        this.flights = data
      } catch (e) {
        console.log('Flights loading error')
        this.flights = []
      }
    },
  },
}
</script>

<style lang="sass" scoped>
@import "@/assets/styles/driver-styles.sass"
.bidsRoot
  padding: 0 1.6rem 4rem
  margin-top: 14.2rem
  max-width: 600px

.flights
  height: 4rem
  margin-bottom: 2rem
  padding: 0 1.2rem
  background: #FFECE1
  border-radius: .8rem
  color: #181818
  cursor: pointer
  &__title
    font-weight: 700
    font-size: 1.4rem
    &-attention
      flex-shrink: 0
      width: 2.4rem
      height: 2.4rem
      margin-right: 0.8rem
      background: url('~@/assets/img/new-attention.svg')
      background-size: cover
  &__info
    height: 2.4rem
    margin-left: .8rem
    padding: 0 .8rem
    border-radius: .6rem
    background: #FFFFFF
    font-weight: 700
    font-size: 1.2rem

    &-icon
      flex-shrink: 0
      width: 1.6rem
      height: 1.6rem
      margin-right: 0.4rem
      &.accept
        background: url('~@/assets/img/new-accept-little.svg')
        background-size: contain
      &.waiting
        background: url('~@/assets/img/new-waiting-little.svg')
        background-size: contain
      &.decline
        background: url('~@/assets/img/new-decline.svg')
        background-size: contain
</style>
